import { render, staticRenderFns } from "./FormularioDeriva.vue?vue&type=template&id=cce14832&"
import script from "./FormularioDeriva.vue?vue&type=script&lang=js&"
export * from "./FormularioDeriva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports